export enum Entry {
  Profile = 'profile',
  Details = 'details',
  Wizard = 'wizard',
  ConsumerProfile = 'consumerProfile',
  DeleteAccountConfirmation = 'deleteAccountConfirmation'
}
